import React from 'react';

export default function DisclosureCaret({ open = false, className = '' }) {
  const classes = ['uiDisclosureCaret'];
  if (open) classes.push('uiDisclosureCaret--open');
  if (className) classes.push(className);

  return <span className={classes.join(' ')} aria-hidden="true" />;
}
